import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import AboutUsLanding from "../views/AboutUsLanding";
import { Helmet } from "react-helmet-async";

export default function AboutUs(props) {

	const appContext = useContext(AppContext);

	const [ view, setView ] = useState(null);

	async function init() {
		//run initializations here
	}

	function getView() {
		if(
			!appContext.navSubItem &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <AboutUsLanding/>
		} 

		return null;
	}

	useEffect(() => {
		init();
	}, [ ])

	useEffect(() => {
		const _view = getView();
		if(_view) {
			setView(_view);
		}
	}, [ appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem ])

	//return desired view
	return (
		<>
    <Helmet>
      <title>About Us | Zanzibar Mission Tours & Safaris</title>
      <meta name="description" content="Learn about Zanzibar Mission Tours & Safaris Company. We offer authentic travel experiences and personalized service in Zanzibar and Tanzania since [YEAR]." />
      <meta property="og:title" content="About Us | Zanzibar Mission Tours & Safaris" />
      <meta property="og:description" content="Learn about Zanzibar Mission Tours & Safaris Company and our commitment to authentic travel experiences." />
      <meta property="og:url" content="https://zanzibarmissiontour.com/#/about_us" />
    </Helmet>
    {view}
  </>
	);
}